import type { Meta } from '@brighterly/lib-core-types/api/interfaces'

interface UseAppTableOptions {
  onChangePage: (page: number) => void
  onChangePerPage: (perPage: number) => void
}

interface UseAppTableReturn {
  handleChangePage: (page: number) => void
  handleChangePerPage: (perPage: number) => void
}

export const DEFAULT_APP_TABLE_META: Meta = {
  per_page: 25,
  current_page: 1,
  last_page: 1,
  from: 0,
  to: 0,
  total: 0,
  next_page_url: null,
  prev_page_url: null,
}

export const useAppTable = ({ onChangePage, onChangePerPage }: UseAppTableOptions): UseAppTableReturn => {
  const handleChangePage = (page: number): void => {
    onChangePage(page)
  }

  const handleChangePerPage = (perPage: number): void => {
    onChangePerPage(perPage)
  }

  return {
    handleChangePage,
    handleChangePerPage,
  }
}
